import Button from 'common/components/buttons/button';
import { ButtonTheme } from 'common/components/buttons/button-theme';
import { ModalSimple } from 'features/modal/modal-simple';
import { useState } from 'react';
import { useSelector } from 'react-redux';
import { areSegmentsInitialState } from '../segment-controls.slice';
import { RootState } from 'app/store';

interface ResetSegmentsButtonProps {
  componentId: string;
  onConfirmModal: () => void;
}

const ResetSegmentsButton = (props: ResetSegmentsButtonProps) => {
  const { componentId, onConfirmModal } = props;
  const [isModalOpen, setIsModalOpen] = useState(false);
  const isInitialState = useSelector((state: RootState) =>
    areSegmentsInitialState(state, componentId)
  );

  const onConfirmResetSegments = () => {
    onConfirmModal();
    setIsModalOpen(false);
  };

  return (
    <>
      <Button
        theme={ButtonTheme.CANCEL}
        identifier="reset-segments"
        isDisabled={isInitialState}
        onClick={() => setIsModalOpen(true)}
      >
        <span>Reset</span>
      </Button>
      <ModalSimple
        isOpen={isModalOpen}
        theme={ButtonTheme.WARNING}
        title="Reset Segments"
        description="Are you sure you want to reset all segments?"
        onCancelModal={() => setIsModalOpen(false)}
        confirmButtonText="Reset"
        onConfirmModal={onConfirmResetSegments}
      />
    </>
  );
};

export default ResetSegmentsButton;
